// @flow
import CommonApi from '../commonApi';
import type { Crew } from '../types';

const basedUrl = 'crew';
const crew = new CommonApi<Crew>(basedUrl, 'расчет потребности в пропусках');

export default crew;
